export default function toFixedAmount(price: Record<string, string>) {
  return Number(price.amount).toFixed(2)
}
